import React, { useState, useEffect } from "react";
import httpClient from "../utils/httpClients";
import { useNavigate, useLocation } from "react-router-dom";
import TopTost from "../utils/topTost";
import { toast } from "react-toastify";

function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [passwordErrors, setPasswordErrors] = useState([]);
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || "";

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const validatePassword = (password) => {
    const errors = [];

    if (password.length < 8) {
      errors.push(
        "Password must be at least 8 characters long. It must contain at least one lowercase letter, one uppercase letter, a number and a special character",
      );
    }

    // if (!/(?=.*[a-z])/.test(password)) {
    //   errors.push("Password must contain at least one lowercase letter");
    // }

    // if (!/(?=.*[A-Z])/.test(password)) {
    //   errors.push("Password must contain at least one uppercase letter");
    // }

    // if (!/(?=.*\d)/.test(password)) {
    //   errors.push("Password must contain at least one number");
    // }

    // if (!/(?=.*[@$!%*?&])/.test(password)) {
    //   errors.push(
    //     "Password must contain at least one special character (@$!%*?&)",
    //   );
    // }

    return errors;
  };

  useEffect(() => {
    if (confirmPassword && password !== confirmPassword) {
      setConfirmPasswordError("Passwords do not match");
    } else {
      setConfirmPasswordError("");
    }
  }, [password, confirmPassword]);

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);

    if (newPassword.length > 0) {
      setPasswordErrors(validatePassword(newPassword));
    } else {
      setPasswordErrors([]);
    }
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoading) return;

    if (!password || !confirmPassword) {
      TopTost.fire({
        icon: "error",
        title: "Please fill in all fields",
      });
      return;
    }

    const errors = validatePassword(password);
    if (errors.length > 0) {
      TopTost.fire({
        icon: "error",
        title: "Please fix password requirements",
        html: errors.join("<br>"),
      });
      return;
    }

    if (password !== confirmPassword) {
      TopTost.fire({
        icon: "error",
        title: "Passwords do not match",
      });
      return;
    }

    setIsLoading(true);

    try {
      const payload = {
        password,
        confirmPassword,
      };

      if (email) {
        payload.email = email;
      }

      const res = await httpClient.patch(
        "/common/auth/reset-password",
        payload,
      );

      // if (res.data?.message) {
      //   toast.success(res.data.message, {
      //     autoClose: 3000,
      //     position: "top-right",
      //   });
      // }

      localStorage.clear();

      navigate("/login", { replace: true });
    } catch (err) {
      console.error("Reset password error:", {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status,
      });
      // TopTost.fire({
      //   icon: "error",
      //   title:
      //     err.response?.data?.message ||
      //     err.message ||
      //     "Failed to reset password. Please try again.",
      // });
    } finally {
      setIsLoading(false);
    }
  };

  const isFormValid =
    passwordErrors.length === 0 &&
    password &&
    confirmPassword &&
    password === confirmPassword;

  return (
    <div className="wrapper">
      <section className="login-content overflow-hidden">
        <div className="row no-gutters align-items-center bg-white">
          <div className="col-md-12 col-lg-6 align-self-center">
            <a
              href="/"
              className="navbar-brand d-flex mt-5 align-items-center mb-3 justify-content-center text-primary"
            >
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/logo.png`}
                alt="Logo"
              />{" "}
            </a>
            <div className="row justify-content-center pt-5 px-4">
              <div className="col-md-9">
                <div className="card d-flex justify-content-center mb-0 auth-card iq-auth-form">
                  <div className="card-body">
                    <h2 className="mb-2 text-center">Reset Password</h2>
                    <p className="text-center">
                      Please enter your new password below.
                    </p>

                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label htmlFor="password" className="form-label">
                              Password
                            </label>
                            <div className="input-group">
                              <input
                                type={showPassword ? "text" : "password"}
                                className="form-control"
                                id="password"
                                value={password}
                                onChange={handlePasswordChange}
                                required
                                minLength="8"
                                aria-describedby="password"
                                placeholder="Enter new password"
                              />
                              <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={togglePasswordVisibility}
                                aria-label={
                                  showPassword
                                    ? "Hide password"
                                    : "Show password"
                                }
                              >
                                <i
                                  className={`fa ${
                                    showPassword ? "fa-eye" : "fa-eye-slash"
                                  }`}
                                ></i>
                              </button>
                            </div>
                            {passwordErrors.length > 0 && (
                              <div className="mt-2">
                                <small className="text-danger">
                                  Password must contain:
                                  <ul className="mb-0 ps-3">
                                    {passwordErrors.map((error, index) => (
                                      <li key={index}>{error}</li>
                                    ))}
                                  </ul>
                                </small>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label
                              htmlFor="confirmPassword"
                              className="form-label"
                            >
                              Confirm Password
                            </label>
                            <div className="input-group">
                              <input
                                type={showConfirmPassword ? "text" : "password"}
                                className={`form-control ${
                                  confirmPasswordError ? "is-invalid" : ""
                                }`}
                                id="confirmPassword"
                                value={confirmPassword}
                                onChange={handleConfirmPasswordChange}
                                required
                                minLength="8"
                                aria-describedby="confirmPassword"
                                placeholder="Confirm new password"
                              />
                              <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={toggleConfirmPasswordVisibility}
                                aria-label={
                                  showConfirmPassword
                                    ? "Hide password"
                                    : "Show password"
                                }
                              >
                                <i
                                  className={`fa ${
                                    showConfirmPassword
                                      ? "fa-eye"
                                      : "fa-eye-slash"
                                  }`}
                                ></i>
                              </button>
                            </div>
                            {confirmPasswordError && (
                              <div className="mt-2">
                                <small className="text-danger">
                                  {confirmPasswordError}
                                </small>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-center mt-4">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={isLoading || !isFormValid}
                        >
                          {isLoading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Resetting...
                            </>
                          ) : (
                            "Reset Password"
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 d-lg-block d-none bg-primary p-0 overflow-hidden">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/auth/01.jpg`}
              className="img-fluid gradient-main"
              alt="login background"
              loading="lazy"
            />
          </div>
        </div>
      </section>
    </div>
  );
}

export default ResetPassword;
